<template>
  <div class="material-item-content" @click="handleClickItem">
    <img :src="materialItemData.image_url" alt="" />
    <div v-if="displayUnlockIcon" class="lock-content flex-center">
      <i class="iconfont iconsuoding"></i>
      <span>未解锁</span>
    </div>
    <div class="material-info-content flex-start">
      <div class="tag flex-center">{{ materialItemData.tag }}</div>
      <div class="title">{{ materialItemData.title }}</div>
    </div>
    <div class="sub-title">{{ materialItemData.subtitle }}</div>
  </div>
</template>

<script>
export default {
  props: {
    materialItemData: {
      type: Object,
      default: () => {},
    },
    invitations: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    displayUnlockIcon() {
      return (
        !this.invitations.find(
          (item) => item.info_id === this.materialItemData.id
        ) && this.invitations.length < 3
      )
    },
  },
  methods: {
    handleClickItem() {
      this.$emit('handleClickItem', this.materialItemData)
    },
  },
}
</script>
<style scoped lang="scss">
@import '../../../assets/scss/global/mixin.scss';
.material-item-content {
  position: relative;
  width: 164px;
  margin-bottom: 16px;
  &:nth-child(odd) {
    margin-right: 15px;
  }
  .lock-content {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 64px;
    height: 24px;
    border-radius: 4px;
    background: rgba($color: #000000, $alpha: 0.6);
    color: #fff;
    font-size: 12px;
    .iconfont {
      margin-right: 2px;
      font-size: 12px;
    }
  }
  img {
    width: 100%;
    height: 87px;
    border-radius: 6px;
    object-fit: cover;
    margin-bottom: 12px;
  }
  .material-info-content {
    margin-bottom: 10px;
    .tag {
      padding: 0 7px;
      height: 18px;
      background: linear-gradient(to right, #ff9f79, #ff6644);
      color: #fff;
      border-radius: 4px;
      white-space: nowrap;
      font-size: 11px;
      margin-right: 4px;
    }
    .title {
      font-size: 14px;
      color: #404040;
      font-weight: 500;
      @include ellipsis(100%);
    }
  }
  .sub-title {
    font-size: 12px;
    color: #606060;
    line-height: 12px;
  }
}
</style>
